export const API_VERSION = 'v1';

// Same error code will be sent to the analytics
export const API_ERROR_CODE = {
    makePayments: '620',
    submitPaymentDetails: '621',
    submitThreeDS2Fingerprint: '622',
    createOrder: '623'
};
